import React, { useState, useEffect } from "react";
import Contact from "../pages/Contact";
import ContactMobile from "../pages/Contact_mobile";

const ContactWrapper = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Check on initial load
    checkScreenSize();

    // Add event listener
    window.addEventListener("resize", checkScreenSize);

    // Clean up event listener
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return (
    <>
      {isMobile ? <ContactMobile /> : <Contact />}
    </>
  );
};

export default ContactWrapper;